module.exports = __webpack_public_path__ + "static/website-avatar-83f36946d559f7b72fdbd858b25d64b7.png";